<div class="payment-reports-container">
  <p-toast></p-toast>

  <!-- <div *ngIf="!isLoading"> -->
  <!-- Header Section -->
  <div>
    <div>
      <div>
        <div class="header-section">
          <div class="title-group">
            <h1>Payment Reports</h1>
            <p>View and analyze payment transactions</p>
          </div>
          <!-- <button pButton type="button" label="Export Report" icon="pi pi-download" (click)="exportReport()"
            [disabled]="isExportLoading" class="p-button-raised export-btn">
          </button> -->
        </div>

        <!-- Summary Cards -->
        <div class="summary-cards" [class.admin-summary]="isAdmin">
          <div class="summary-card">
            <div class="card-content">
              <div class="card-info">
                <span class="card-label">Total Transactions</span>
                <span class="card-value">{{ summary.totalTransactions }}</span>
              </div>
              <div class="card-icon filter-icon">
                <i class="pi pi-filter"></i>
              </div>
            </div>
          </div>

          <div class="summary-card" *ngIf="!isAdmin">
            <div class="card-content">
              <div class="card-info">
                <span class="card-label">Total Amount</span>
                <span class="card-value">{{ formatCurrency(summary.totalAmount) }}</span>
              </div>
              <div class="card-icon rupee-icon">
                <i class="pi pi-indian-rupee"></i>
              </div>
            </div>
          </div>

          <div class="summary-card" *ngIf="!isAdmin">
            <div class="card-content">
              <div class="card-info">
                <span class="card-label">Successful Payments</span>
                <span class="card-value">{{ summary.successfulPayments }}</span>
              </div>
              <div class="card-icon success-icon">
                <i class="pi pi-check-circle"></i>
              </div>
            </div>
          </div>

          <div class="summary-card" *ngIf="!isAdmin">
            <div class="card-content">
              <div class="card-info">
                <span class="card-label">Success Amount</span>
                <span class="card-value">{{ formatCurrency(summary.successAmount) }}</span>
              </div>
              <div class="card-icon rupee-icon">
                <i class="pi pi-indian-rupee"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Filters Section -->
        <div class="filters-section" *ngIf="showFilters">
          <div class="filters-header">
            <h2>
              <i class="pi pi-filter"></i>
              Filters
            </h2>
            <div class="filter-actions">
              <button pButton type="button" label="Clear All" icon="pi pi-times" (click)="clearAllFilters()"
                class="p-button-text clear-btn">
              </button>
              <button pButton type="button" label="Hide Filters" (click)="toggleFilters()"
                class="p-button-text hide-btn">
              </button>
            </div>
          </div>

          <form [formGroup]="filterForm" (ngSubmit)="onFilter()" class="filters-form">
            <div class="filters-grid">
              <div class="filter-field">
                <label>Search</label>
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input type="text" pInputText formControlName="searchText"
                    placeholder="Search by name, email, order ID..." class="w-full" />
                </span>
              </div>

              <div class="filter-field">
                <label>Package</label>
                <p-dropdown [options]="packages" formControlName="packageId" optionLabel="name" optionValue="id"
                  [showClear]="true" placeholder="All Packages" styleClass="selectFull" class="w-full">
                </p-dropdown>
              </div>

              <div class="filter-field">
                <label>Status</label>
                <p-dropdown [options]="statusOptions" formControlName="status" optionLabel="label" optionValue="value"
                  [showClear]="true" placeholder="All Status" styleClass="selectFull" class="w-full">
                </p-dropdown>
              </div>

              <div class="filter-field">
                <label>Payment Mode</label>
                <p-dropdown [options]="paymentMethodOptions" formControlName="paymentMethod" optionLabel="label"
                  optionValue="value" [showClear]="true" placeholder="All Methods" styleClass="selectFull"
                  class="w-full">
                </p-dropdown>
              </div>

              <div class="filter-field">
                <label>Date Range</label>
                <p-calendar formControlName="dateRange" selectionMode="range" [showIcon]="true" dateFormat="dd/mm/yy"
                  placeholder="Select date range" styleClass="w-full">
                </p-calendar>
              </div>

              <div class="filter-field search-btn-field">
                <label>&nbsp;</label>
                <button pButton type="submit" icon="pi pi-search" class="p-button-raised search-filter-btn"
                  pTooltip="Search" tooltipPosition="top">
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="show-filters-btn" *ngIf="!showFilters">
          <button pButton type="button" label="Show Filters" icon="pi pi-filter" (click)="toggleFilters()"
            class="p-button-text">
          </button>
        </div>

        <!-- Payment Transactions Table -->
        <div class="transactions-section">
          <h2>Payment Transactions</h2>

          <div *ngIf="transactions.length > 0; else noDataTemplate">
            <p-table [value]="transactions" [loading]="isLoading" [paginator]="true" [rows]="10"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              styleClass="p-datatable-striped">

              <ng-template pTemplate="header">
                <tr>
                  <th>Order ID</th>
                  <th>Customer</th>
                  <th>Package</th>
                  <th *ngIf="!isAdmin">Amount</th>
                  <th *ngIf="isAdmin">Email</th>
                  <th *ngIf="isAdmin">Phone Number</th>
                  <th>Payment Mode</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th *ngIf="!isAdmin">Actions</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-transaction>
                <tr>
                  <td>
                    <div class="order-id">
                      <div class="order-number">{{ transaction.orderId }}</div>
                      <div class="transaction-id">({{ transaction.transactionId }})</div>
                    </div>
                  </td>
                  <td>
                    <div class="customer-info">
                      <div class="customer-name">{{ transaction.customerName }}</div>
                      <div class="customer-email" *ngIf="!isAdmin">{{ transaction.customerEmail }}</div>
                    </div>
                  </td>
                  <td>{{ transaction.packageName }}</td>
                  <td *ngIf="!isAdmin">
                    <div class="amount-info">
                      <div class="amount">{{ formatCurrency(transaction.amount) }}</div>
                      <div class="discount" *ngIf="transaction.discountAmount && transaction.discountAmount > 0">
                        -{{ formatCurrency(transaction.discountAmount) }} discount
                      </div>
                    </div>
                  </td>
                  <td *ngIf="isAdmin">{{ transaction.customerEmail }}</td>
                  <td *ngIf="isAdmin">{{ transaction.phoneNumber }}</td>
                  <td>{{ transaction.paymentMethod }}</td>
                  <td>
                    <span class="status-badge" [ngClass]="getStatusClass(transaction.status)">
                      {{ transaction.status }}
                    </span>
                  </td>
                  <td>{{ formatDateDisplay(transaction.date) }}</td>
                  <td *ngIf="!isAdmin">
                    <div class="actions">
                      <button *ngIf="transaction.status === 'Success'" pButton type="button" label="Refund"
                        icon="pi pi-replay" class="p-button-sm p-button-warning" (click)="onRefund(transaction)"
                        pTooltip="Refund this transaction" tooltipPosition="top">
                      </button>

                      <button *ngIf="transaction.status === 'In Progress'" pButton type="button" label="Update Status"
                        icon="pi pi-refresh" class="p-button-sm p-button-info" (click)="onUpdateStatus(transaction)"
                        pTooltip="Update payment status" tooltipPosition="top">
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="8" class="text-center">No transactions found</td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <ng-template #noDataTemplate>
            <div class="no-data">
              <img src="../../../assets/icons/nodatafound.svg" alt="No data found" class="no-data-image">
              <b class="no-data-text">No Data Found !</b>
            </div>
          </ng-template>
        </div>
      </div>
      <!--
  <div *ngIf="isLoading" class="loading-container">
    <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s">
    </p-progressSpinner>
  </div> -->


      <p-dialog [(visible)]="showRefundDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
        styleClass="refund-dialog" header="Process Refund">
        <div class="refund-dialog-content">
          <div class="transaction-info">
            <h3>Transaction Details</h3>

            <div class="info-row">
              <span class="label">Transaction Number:</span>
              <span class="value">{{ selectedTransaction?.transactionId }}</span>
            </div>
            <div class="info-row">
              <span class="label">Customer Name:</span>
              <span class="value">{{ selectedTransaction?.customerName }}</span>
            </div>
            <div class="info-row">
              <span class="label">Package Name:</span>
              <span class="value">{{ selectedTransaction?.packageName }}</span>
            </div>
            <div class="info-row">
              <span class="label">Original Amount:</span>
              <span class="value amount">{{ formatCurrency(selectedTransaction?.amount || 0) }}</span>
            </div>
          </div>

          <form [formGroup]="refundForm" class="refund-form">
            <div class="form-field">
              <label for="refundAmount">Refund Amount <span class="required">*</span></label>
              <div class="amount-input-wrapper">
                <span class="currency-symbol">₹</span>
                <input id="refundAmount" type="number" pInputText formControlName="amount"
                  placeholder="Enter refund amount" class="amount-input" [max]="selectedTransaction?.amount || null"
                  min="1" />
              </div>
              <small class="max-amount-hint">Maximum: {{ formatCurrency(selectedTransaction?.amount || 0) }}</small>
              <small class="error-message"
                *ngIf="refundForm.get('amount')?.invalid && refundForm.get('amount')?.touched">
                <span *ngIf="refundForm.get('amount')?.errors?.['required']">Refund amount is required</span>
                <span *ngIf="refundForm.get('amount')?.errors?.['min']">Amount must be greater than 0</span>
                <span *ngIf="refundForm.get('amount')?.errors?.['max']">Amount cannot exceed original transaction
                  amount</span>
              </small>
            </div>
          </form>
        </div>

        <ng-template pTemplate="footer">
          <div class="dialog-footer">
            <button pButton type="button" label="Cancel" class="p-button-text p-button-secondary"
              (click)="closeRefundDialog()" [disabled]="isRefundProcessing">
            </button>
            <button pButton type="button" label="Process Refund" icon="pi pi-check"
              class="p-button-raised p-button-warning" (click)="processRefund()" [loading]="isRefundProcessing"
              [disabled]="refundForm.invalid">
            </button>
          </div>
        </ng-template>
      </p-dialog>
    </div>